export default function stripTags() {
    return function (input) {
        return input.replace(/(<([^>]+)>)/ig, '');
    };
}

stripTags.$inject = [];



// WEBPACK FOOTER //
// ./src/javascripts/ng-admin/Main/component/filter/StripTags.js